(function () {
    angular.module('directives')
        .directive('draggableItem', [function () {
        return {
            restrict: 'A',
            scope: {
                onDragStart: '&',
                onDragEnd: '&',
                initWithDrag: '<?',
                preventDragging: '<?'
            },
            link: function (scope, element) {
                let x = 0;
                let y = 0;
                let ele = element[0];
                let width = 0;
                let draggingEle = null;
                let isDraggingStarted = false;
                let placeholder = null;
                let parentNode = ele.parentNode;
                let oldOrder = 0;
                let newOrder = 0;
                let stopDragging = false;

                element.on('mousedown', mouseDownHandler);

                function simulateMouseDown() {
                    mouseDownHandler();
                }

                function mouseDownHandler(e) {
                    if (scope.preventDragging) return;
                    stopDragging = false;
                    draggingEle = ele;
                    oldOrder = Array.prototype.indexOf.call(parentNode.children, ele);
                    let rect = draggingEle.getBoundingClientRect();
                    x = e.clientX - rect.left;
                    y = e.clientY - rect.top;
                    width = rect.width;
                    draggingEle.style.cursor = 'grabbing';
                    document.addEventListener('mousemove', mouseMoveHandler);
                    document.addEventListener('mouseup', mouseUpHandler);
                    e && e.preventDefault();
                }

                function mouseMoveHandler(e) {
                    if (stopDragging) return;
                    let draggingRect = draggingEle.getBoundingClientRect();
                    if (!isDraggingStarted) {
                        isDraggingStarted = true;
                        placeholder = angular.element('<div class="dnd-placeholder"></div>');
                        angular.element(draggingEle).after(placeholder);
                        placeholder.css('height', draggingRect.height + 'px');
                        placeholder.css('width', '100%');
                    }
                    draggingEle.style.width = width + 'px';
                    draggingEle.style.position = 'fixed';
                    draggingEle.style.top = (e.clientY - y) + 'px';
                    draggingEle.style.left = (e.clientX - x) + 'px';
                    let prevEle = draggingEle.previousElementSibling;
                    let nextEle = placeholder[0].nextElementSibling;
                    if (prevEle && isAbove(draggingEle, prevEle)) {
                        swap(placeholder[0], draggingEle);
                        swap(placeholder[0], prevEle);
                        return;
                    }
                    if (nextEle && isAbove(nextEle, draggingEle)) {
                        swap(nextEle, placeholder[0]);
                        swap(nextEle, draggingEle);
                    }
                }

                function mouseUpHandler() {
                    draggingEle.style.cursor = 'auto';
                    placeholder && placeholder.remove();
                    isDraggingStarted = false;
                    draggingEle.style.removeProperty('top');
                    draggingEle.style.removeProperty('left');
                    draggingEle.style.removeProperty('position');
                    x = 0;
                    y = 0;
                    document.removeEventListener('mousemove', mouseMoveHandler);
                    document.removeEventListener('mouseup', mouseUpHandler);
                    stopDragging = true;
                    newOrder = Array.prototype.indexOf.call(parentNode.children, ele);
                    scope.onDragEnd({oldOrder: oldOrder, newOrder: newOrder});
                }

                function isAbove(nodeA, nodeB) {
                    let rectA = nodeA.getBoundingClientRect();
                    let rectB = nodeB.getBoundingClientRect();
                    return rectA.top + rectA.height / 2 < rectB.top + rectB.height / 2;
                }

                function swap(nodeA, nodeB) {
                    let parentA = nodeA.parentNode;
                    let siblingA = nodeA.nextSibling === nodeB ? nodeA : nodeA.nextSibling;
                    nodeB.parentNode.insertBefore(nodeA, nodeB);
                    parentA.insertBefore(nodeB, siblingA);
                }

                if (scope.initWithDrag) {
                    simulateMouseDown();
                }

                scope.$on('$destroy', function () {
                    element.off('mousedown', mouseDownHandler);
                });
            }
        };
    }]);
})();
